import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ContentChildren,
    Inject,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { KAL_DIALOG_DATA, KalDialogRef, KalSelectionModel } from '@kalidea/kaligraphi';
import { BaseComponent } from 'src/app/_core/tools/base.component';
import { SharedBeneficiaryListFiltersComponent } from 'src/app/_shared/components/shared-beneficiary-list-filters/shared-beneficiary-list-filters.component';
import { SharedBeneficiaryListComponent } from 'src/app/_shared/components/shared-beneficiary-list/shared-beneficiary-list.component';
import { catchError, tap } from 'rxjs/operators';
import { filterListFromSelection } from 'src/app/utils/list.utils';
import { throwError } from 'rxjs';

export interface SharedBeneficiaryListDialogData {
    accepted?: boolean;
    selection: KalSelectionModel<any>;
    hiddenBeneficiaryIdList?: number[];
    selectedBeneficiaries?: { [key: string]: string }[];
}

@Component({
    selector: 'app-shared-beneficiary-list-dialog',
    templateUrl: './shared-beneficiary-list-dialog.component.html',
    styleUrls: ['./shared-beneficiary-list-dialog.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SharedBeneficiaryListDialogComponent extends BaseComponent {

    @ViewChild(SharedBeneficiaryListComponent) beneficiaryListComponent: SharedBeneficiaryListComponent;

    @ContentChildren(SharedBeneficiaryListFiltersComponent)

    beneficiaryListFiltersComponent: SharedBeneficiaryListFiltersComponent;

    constructor(private readonly dialogRef: KalDialogRef<SharedBeneficiaryListDialogComponent>,
                protected readonly cdr: ChangeDetectorRef,
                @Inject(KAL_DIALOG_DATA) public data: SharedBeneficiaryListDialogData) {
        super(cdr);
    }

    close(): void {
        this.dialogRef.close();
    }

    submit(): void {
        if (!this.beneficiaryListComponent.hasSelection) {
            return;
        }

        if (!this.data.selection.multiple || !this.data.selection.all) {
            this.dialogRef.close({
                accepted: true,
                selectedBeneficiaries: this.beneficiaryListComponent.selection.added
            });

            return;
        }

        this.loading = true;
        this.watch$ = this.beneficiaryListComponent.getAll$().pipe(
            tap(() => {
                this.loading = false;

                this.dialogRef.close({
                    accepted: true,
                    selectedBeneficiaries: filterListFromSelection(this.beneficiaryListComponent.dataSource.rows, this.beneficiaryListComponent.selection, 'ID')
                });
            }),
            catchError(err => {
                this.loading = false;
                return throwError(() => err);
            })
        );
    }
}
